import React from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// MUI
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';
// Components
import Title from 'components/Title';
// Hooks
import useScrollIntoView from 'hooks/useScrollIntoView';
// Framer
import { motion } from 'framer-motion';
import { bottomAnimate, topAnimate } from 'utilities/Framer';

const Brands:React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const { scrollTo } = useScrollIntoView();

  return (
    <motion.section
      data-container="brands"
      className={classes.block}
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <div className={[classes.blockContent, 'container'].join(' ')}>
        <motion.div variants={bottomAnimate} custom={1}>
          <Title>{t('homePage.brands.label')}</Title>
        </motion.div>
        <motion.h2 className={classes.title} variants={topAnimate} custom={1}>
          {t('homePage.brands.title')}
        </motion.h2>
        <motion.p className={classes.text} variants={topAnimate} custom={2}>
          {t('homePage.brands.text')}
        </motion.p>
        <motion.p className={classes.note} variants={topAnimate} custom={3}>
          {t('homePage.brands.note')}
        </motion.p>
        <Button variant="contained" onClick={() => scrollTo('contacts')}>
          {t('homePage.brands.button')}
        </Button>
      </div>
    </motion.section>
  );
}

export default Brands;

const useStyles = makeStyles({
  block: {
    position: 'relative',
    padding: '16px',
    '@media (min-width: 600px)': {
      padding: '32px'
    },
    '@media (min-width: 1240px)': {
      padding: '40px 32px'
    },
  },
  blockContent: {
    paddingTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    textAlign: 'center',
    '@media (min-width: 600px)': {
      paddingTop: '32px',
    },
    '@media (min-width: 1240px)': {
      paddingTop: '56px',
    },
  },
  title: {
    color: '#0e073c',
    letterSpacing: '1px',
    fontSize: '30px',
    margin: '20px 0 0',
    '@media (min-width: 600px)': {
      fontSize: '36px',
    },
    '@media (min-width: 1240px)': {
      fontSize: '48px',
    },
  },
  text: {
    color: '#0e073c',
    fontSize: '18px',
    fontWeight: 600,
    maxWidth: '900px',
    lineHeight: 1.6,
  },
  note: {
    color: '#696393',
    fontSize: '16px',
    maxWidth: '900px',
  },
});
